import { useEffect, useRef } from "react";
import { socket } from "../../socket";

export const useSocket = () => {
  const socketRef: any = useRef(null); // Persistent across renders

  useEffect(() => {
    if (!socketRef.current) {
      socketRef.current = socket;
      socketRef.current.connect();

      socketRef.current.on("connect", () => {
        console.info("Socket connected");
      });

      socketRef.current.on("disconnect", () => {
        console.info("Socket disconnected");
      });
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.off("connect");
        socketRef.current.off("disconnect");
      }
    };
  }, []);

  return socketRef.current;
};

export const useSocketListener = ({
  eventName,
  handlerFunction,
}: {
  eventName: string;
  handlerFunction: (data: any) => unknown;
}) => {
  useEffect(() => {
    socket.on(eventName, handlerFunction);

    return () => {
      socket.off(eventName, handlerFunction);
    };
  }, [eventName, handlerFunction]);
};
